import articleApi from 'api/article';
import ArticleContents from 'components/articles/articleContents';
import EmailModal from 'components/layout/emailModal';
import events from 'lib/events';
import FooterButton from 'components/layout/footerButton';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import PageFooter from 'components/layout/pageFooter';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import SearchField from 'components/searchField';
import session from 'services/sessionService';
import {emailSendingTypes} from 'helpers/constants';
import {intlShape, injectIntl} from 'react-intl';

let render = (container, params) => {
  console.info('[UI.page.supportArticle] rendering page');
  ReactDOM.render(<IntlWrapper>
    <WrappedSupportArticlePage slug={params.articleSlug}/>
  </IntlWrapper>, container);
  events.publish('page-change', {page: 'supportArticle'});
};

console.info('[UI.page.supportArticle] register route');
router.rr.add([{path: 'support/:articleSlug', handler: routeUtils.requireAuth(render)}]);

// Page object
class SupportArticlePage extends React.Component {
  static propTypes = {
    intl: intlShape,
    slug: PropTypes.string,
  };

  state = {
    topic: '',
    query: '',
    article: undefined,
    topics: [],
  };

  componentDidMount() {
    this.fetchCurrentArticle(this.props.slug);
    articleApi.getSupportTopics().then(topics => this.setState({topics: topics}));
  }

  componentWillReceiveProps(newProps) {
    this.fetchCurrentArticle(newProps.slug);
  }

  changeHandler = (property, after = null, valueProperty = 'value') => {
    return event => {
      this.setState({[property]: event.target[valueProperty]});
      if (after) {
        after();
      }
    };
  };

  fetchCurrentArticle = (slug) => {
    let {formatMessage} = this.props.intl;

    articleApi.getArticle(slug).then(article => {
      this.setState({article});
    }).catch(error => {
      if (error.code === 404) {
        let article = {
          title: formatMessage({id: 'general.article.not.found'}),
          body: formatMessage({id: 'general.not.article.requested'}),
        };

        this.setState({article});
      } else {
        throw error;
      }
    });
  };

  filterChange = (text, submitted) => {
    this.setState({query: text});

    if (submitted) {
      session.setSearch(text, this.state.topic);
      window.location.hash = 'support';
    }
  };

  render() {
    let {formatMessage} = this.props.intl;

    return (
      <div id='page-support-article'
           className='container'>
        <Header mainTitle={formatMessage({id: 'support.title'})}
                subTitle={this.state.article && this.state.article.topic ? this.state.article.topic.Name : 'Article'}
                mainTitleReturn='support'/>
        <div className='well clearfix'>
          <div className='col-sm-4'>
            <SearchField placeholder={formatMessage({id: 'general.search.articles.keyboards'})}
                         onSearch={this.filterChange}/>
          </div>
          <div className='col-sm-4'>
            <div className='form-group'>
              <select className='form-control'
                      value={this.state.topic}
                      onChange={this.changeHandler('topic', this.updateURL)}>
                <option value=''>{formatMessage({id: 'general.select.topic'})}</option>
                {this.state.topics.map(topic => <option key={topic.ID}
                                                        value={topic.Name}>{topic.Name}</option>)}
              </select>
            </div>
          </div>
        </div>

        <ArticleContents article={this.state.article}
                         formatMessage={formatMessage}/>

        <PageFooter>
          <FooterButton label='Print'
                        icon='bl bl-print fa-2x'
                        onClick={() => events.publish('print', <ArticleContents article={this.state.article}
                                                                                formatMessage={formatMessage}/>)}/>
          <EmailModal
            title={formatMessage({id: 'general.article'})}
            target={this.state.article && this.state.article.id ? this.state.article.id : undefined}
            type={emailSendingTypes.encyclopedia}/>
        </PageFooter>
      </div>
    );
  }
}

const WrappedSupportArticlePage = injectIntl(SupportArticlePage);

export default WrappedSupportArticlePage;
